import React from 'react'
import AppleOAuthButton from '../AppleOAuthButton'
import GoogleOAuthButton from '../GoogleOAuthButton'
import FacebookOAuthButton from '../FacebookOAuthButton/'
import { AuthenticatedUserFragment } from '../../../../fragments/AuthenticatedUser.generated'
import styles from './styles.css'

interface OAuthButtonsProps {
  referralCodeId?: string | null
  registrationId?: string | null
  onSuccess: (user: AuthenticatedUserFragment) => void
  onFailure: (error: string) => void
}

const OAuthButtons: React.FC<OAuthButtonsProps> = props => {
  return (
    <div className={styles.oAuth}>
      <AppleOAuthButton {...props} wrapperClassName={styles.oAuthButton} />
      <GoogleOAuthButton {...props} wrapperClassName={styles.oAuthButton} />
      <FacebookOAuthButton {...props} wrapperClassName={styles.oAuthButton} />
    </div>
  )
}

export default OAuthButtons
